export default "__VITE_ASSET__9a920c63__"